import React from "react";
import PropTypes from "prop-types";

function TransparentTextInput({
  id,
  name,
  type,
  value,
  placeholder,
  onChange,
  error = "",
  disabled = false,
  UpperCaseValue,
  dataKey,
  errorLabel,
  fontSize,
  width,
  maxLength,
}) {
  const textTransform = UpperCaseValue ? "uppercase" : undefined;

  return (
    <>
      <div>
        <input
          id={id}
          type={type}
          onChange={onChange}
          name={name}
          className="form-control"
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          data-key={dataKey}
          autoComplete="off"
          maxLength={maxLength}
          style={{
            backgroundColor: "transparent",
            border: "none",
            textAlign: "center",
            textTransform,
            fontSize,
            width,
          }}
        />
      </div>

      {error && (
        <div
          style={{
            textAlign: "center",
            color: "#dc3545",
            fontSize: "14px",
            maxWidth: "100%",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            wordBreak: "break-all",
          }}
        >
          {errorLabel}
        </div>
      )}
    </>
  );
}

TransparentTextInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default TransparentTextInput;
